import { SidebarLayoutComponent } from '@app/sidebar-layout/sidebar-layout.component';
import { SidebarLayoutGuard } from '@app/guards/sidebar-layout.guard';
import { Route, Routes } from '@angular/router';

export class SidebarLayout {
	static childRoutes(routes: Routes): Route {
		return {
			canActivate: [SidebarLayoutGuard],
			component: SidebarLayoutComponent,
			children: routes,
			path: '',
		};
	}
}
